import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { isAnnualMaskReceiptDateValid } from "./annualMaskPurchaseUtils";

export const AnnualMaskReceiptDateText = ({ date }) => (
  <span>Expected mask receipt: {date ? <strong>{date}</strong> : <span className="text-muted">Not scheduled</span>}</span>
);

const AnnualMaskReceiptDate = ({ date = "", disabled, onSave, embedded = false }) => {
  const [draft, setDraft] = useState(date);
  useEffect(() => setDraft(date), [date]);
  return (
    <div className={embedded ? "" : "my-3"}>
      {!embedded && <div className="font-weight-bold mb-1">Schedule patient mask receipt</div>}
      <AnnualMaskReceiptDateText date={date} />
      <div className="d-flex align-items-center mt-2">
        <Form.Control
          type="date"
          size="sm"
          aria-label="Expected mask receipt date"
          value={draft}
          disabled={disabled}
          onChange={(event) => setDraft(event.target.value)}
          style={{ maxWidth: 200 }}
        />
        <Button size="sm" className="ml-2" disabled={disabled || draft === date || !isAnnualMaskReceiptDateValid(draft)} onClick={() => onSave(draft)}>
          Save date
        </Button>
      </div>
      {!embedded && <small className="text-muted">Save the date the patient is expected to receive the mask before Ready to Purchase.</small>}
    </div>
  );
};

export default AnnualMaskReceiptDate;
